import { IUserRights } from "../Providers.Api/Models.UserApi";
import { ODataSelect } from "@iconics/core";

export interface IUserDetails
{
    displayName: string;
    email: string;
    userType: string;
    providerType?: SecurityProviderEnum;
    userRights: IUserRights;
}

export class NodeData extends ODataSelect
{
    public ID = 0;
    public Parent_ID: number | null = 0;
    public Name = '';
    public DisplayName = '';
    public IsEnabled = false;
    public SortOrder = '';
    public Level = '';
    public TimeZone = '';
    public TimeZoneType = '';
    public TimeZoneDST = false;
}

export type SecurityProviderEnum = 'Native' | 'AAD' | 'Okta' | 'B2C'